var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "print_svg2__a",
    x1: 29.42,
    x2: 162.44,
    y1: 184.67,
    y2: 25.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#print_svg2__a",
    id: "print_svg2__c",
    x1: 61.8,
    x2: 194.82,
    y1: 211.66,
    y2: 52.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#print_svg2__a",
    id: "print_svg2__d",
    x1: 53.6,
    x2: 186.62,
    y1: 204.83,
    y2: 45.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#print_svg2__a",
    id: "print_svg2__e",
    x1: 35.57,
    x2: 168.59,
    y1: 189.8,
    y2: 30.23
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M179.17 50h-20.83V20.83C158.34 9.35 149 0 137.51 0H62.5C51.01 0 41.67 9.35 41.67 20.83V50H20.84C9.35 50 .01 59.35.01 70.83v58.33c0 11.48 9.34 20.83 20.83 20.83h20.83v29.17c0 11.48 9.34 20.83 20.83 20.83h75c11.49 0 20.83-9.35 20.83-20.83v-29.17h20.83c11.49 0 20.83-9.35 20.83-20.83V70.83c0-11.48-9.34-20.83-20.83-20.83ZM50 20.83c0-6.89 5.61-12.5 12.5-12.5h75c6.89 0 12.5 5.61 12.5 12.5V50H50zm100 158.34c0 6.89-5.61 12.5-12.5 12.5h-75c-6.89 0-12.5-5.61-12.5-12.5v-62.5h100zm41.67-50c0 6.89-5.61 12.5-12.5 12.5h-20.83V112.5c0-2.3-1.87-4.17-4.17-4.17H45.83c-2.3 0-4.17 1.87-4.17 4.17v29.17H20.83c-6.89 0-12.5-5.61-12.5-12.5V70.84c0-6.89 5.61-12.5 12.5-12.5h158.33c6.89 0 12.5 5.61 12.5 12.5v58.33Z",
    style: {
      fill: "url(#print_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83 166.67h-50c-2.3 0-4.17 1.87-4.17 4.17s1.87 4.17 4.17 4.17h50c2.3 0 4.17-1.87 4.17-4.17s-1.87-4.17-4.17-4.17",
    style: {
      fill: "url(#print_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83 150h-50c-2.3 0-4.17 1.87-4.17 4.17s1.87 4.17 4.17 4.17h50c2.3 0 4.17-1.87 4.17-4.17s-1.87-4.17-4.17-4.17",
    style: {
      fill: "url(#print_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83 141.67H87.5c2.3 0 4.17-1.87 4.17-4.17s-1.87-4.17-4.17-4.17H70.83c-2.3 0-4.17 1.87-4.17 4.17s1.87 4.17 4.17 4.17",
    style: {
      fill: "url(#print_svg2__e)",
      strokeWidth: 0
    }
  }));
};
export default SvgPrint;